import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import Home from './pages/Home';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Standings from './pages/Standings';
import Betting, { BettingPageLoading } from './pages/Betting';
import Store from './pages/Store';
import PrivateLeagues, { LeaguesPageLoading } from './pages/PrivateLeagues';
import Profile from './pages/Profile';
import Account from './pages/Account';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';


function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/standings" element={<Standings />} />
              <Route path="/profile/:username" element={<Profile />} />
              <Route
                path="/account"
                element={
                  <ProtectedRoute>
                    <Account />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/picks"
                element={
                  <ProtectedRoute fallback={<BettingPageLoading />}>
                    <Betting />
                  </ProtectedRoute>
                }
              />
              <Route path="/betting" element={<Navigate to="/picks" replace />} />
              <Route
                path="/store"
                element={
                  <ProtectedRoute>
                    <Store />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/leagues"
                element={
                  <ProtectedRoute fallback={<LeaguesPageLoading />}>
                    <PrivateLeagues />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

